/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrgDetailsDto } from './OrgDetailsDto';
import {
    OrgDetailsDtoFromJSON,
    OrgDetailsDtoFromJSONTyped,
    OrgDetailsDtoToJSON,
} from './OrgDetailsDto';

/**
 * 
 * @export
 * @interface OrgFillingDetailRequestDto
 */
export interface OrgFillingDetailRequestDto {
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof OrgFillingDetailRequestDto
     */
    orgId: string;
    /**
     * 
     * @type {OrgDetailsDto}
     * @memberof OrgFillingDetailRequestDto
     */
    orgDetails?: OrgDetailsDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrgFillingDetailRequestDto
     */
    publicRecordLinks?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrgFillingDetailRequestDto
     */
    scopedOrgId?: string;
}

/**
 * Check if a given object implements the OrgFillingDetailRequestDto interface.
 */
export function instanceOfOrgFillingDetailRequestDto(value: object): boolean {
    if (!('orgId' in value)) return false;
    return true;
}

export function OrgFillingDetailRequestDtoFromJSON(json: any): OrgFillingDetailRequestDto {
    return OrgFillingDetailRequestDtoFromJSONTyped(json, false);
}

export function OrgFillingDetailRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgFillingDetailRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'orgId': json['orgId'],
        'orgDetails': json['orgDetails'] == null ? undefined : OrgDetailsDtoFromJSON(json['orgDetails']),
        'publicRecordLinks': json['publicRecordLinks'] == null ? undefined : json['publicRecordLinks'],
        'scopedOrgId': json['scopedOrgId'] == null ? undefined : json['scopedOrgId'],
    };
}

export function OrgFillingDetailRequestDtoToJSON(value?: OrgFillingDetailRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orgId': value['orgId'],
        'orgDetails': OrgDetailsDtoToJSON(value['orgDetails']),
        'publicRecordLinks': value['publicRecordLinks'],
        'scopedOrgId': value['scopedOrgId'],
    };
}

